import Cookies from 'js-cookie';
import CookieStorage from './cookie-storage';
type CookiesStatic = typeof Cookies;

const nonSessionCognitoCookieNames = ['deviceKey', 'deviceGroupKey', 'randomPasswordKey', 'devicesPendingClear'];

export function clearCognitoCookies(cookies: CookiesStatic): void {
  const allCookies = cookies.get();

  for (const cookie of Object.keys(allCookies)) {
    const deviceCookie = isDeviceCookie(cookie);
    if (deviceCookie) continue; // Don't clear device tracking cookies, as these are needed for Cognito's device tracking to work correctly
    cookies.remove(cookie, { domain: window.location.hostname });
  }
}

export function isDeviceCookie(cookieName: string): boolean {
  return nonSessionCognitoCookieNames.some(name => cookieName.includes(name));
}

const deviceCookieNames = ['deviceKey', 'deviceGroupKey', 'randomPasswordKey'];

export function clearStaleDeviceCookies(cookies: CookieStorage, appClient: string, username: string): void {
  const keyPrefix = `CognitoIdentityServiceProvider.${appClient}.${username}`;
  for (const name of deviceCookieNames) {
    const key = `${keyPrefix}.${name}`;
    cookies.removeItem(key);
    localStorage.removeItem(key);
  }
}
